import Main from '../containers/Main'
import Services from '../containers/Services'
import Projects from '../containers/Projects'
import About from '../containers/About'
import Technologies from '../containers/Technologies'
import Tours from '../containers/Tours'
import Designers from '../containers/Designers'

export default [
  {
    title: 'Главная',
    component: Main,
    exact: true,
    path: '/',
  },

  {
    title: 'Услуги',
    component: Services,
    path: '/services',
    data: {
      title: 'Наши услуги',
      description:
        'За плодотворные годы функционирования, мы выработали отлаженные и надежные системы ведения бизнеса в Китае, включая:',
      list: [
        '• Услуги подбора качественных производителей и поиск нужного вам товара',
        '• Оформление заказов по каталогам производителей',
        '• Размещение заказа на производстве',
        '• Инспекционный контроль качества производства и готовой продукции',
        '• Складские услуги и консолидация грузов',
        '• Таможенное оформление грузов, погрузка и транспортировка до места назначения',
      ],
    },
    atemption: {
      html:
        'Команда China Pro зарекомендовала себя одним из главных <br/> игроков на рынке HoReCa.Многолетний опыт работы, <br/> позволяет нам предоставлять вам лучшие и наиболее <br/> подходящие вашему дизайн- проекту решения, осуществляя <br/> всевозможные задумки.',
    },
  },

  {
    title: 'Проекты',
    component: Projects,
    path: '/projects',
    data: {
      title: 'Проекты',
    },
  },

  {
    title: 'Технология работы',
    component: Technologies,
    path: '/technologies',
    data: {
      title: 'Технологии производства',
      description:
        'Наша компания осуществляет грамотную организацию производства и поставки нужной вам продукции на выгодных условиях и с наиболее оптимальными вариантами логистики.',
    },
  },

  {
    title: 'Дизайн студии',
    component: Designers,
    path: '/designers',
    data: {
      title: 'Дизайнеры интерьера',
      description:
        'Мы выбираем самых лучших, профессиональных <br/> и ответственных дизайнеров для работы с вами.',
    },
  },

  {
    title: 'Спец Предложения',
    component: Tours,
    path: '/tours',
    data: {
      title: 'Закажите мебельный тур в Китай',
      description: [
        'Для заинтересованных лиц, мы также занимаемся организацией бизнес и шоп-туров по промышленым мегаполисам Китая.',
        'В наши услуги входит разработка маршрута тура, оформление виз, бронирование авиабилетов, гостиниц, полное сопровождение профессионального гида- переводчика, консалтинговые услуги в течении поездки.',
      ],
    },
  },

  {
    title: 'О нас',
    component: About,
    path: '/about',
    data: {
      title: 'О нас',
      description:
        'С 2008 года China Pro успешно предоставляет широкий спектр услуг комплексного оснащения мебелью, освещением, сантехникой, керамикой, декором для:',
      list: [
        '• гостиниц и пансионатов;',
        '• банкетных залов, ресторанов и кофеен;',
        '• бизнес-центров, офисов и коворкинг пространств;',
      ],
    },
    atemption: {
      html:
        'Мы работаем с ведущими дизайнерскими студиями для создания уникальных проектов <br/> и максимально облегчаем процесс его подготовки и запуска, предлагая эксклюзивный <br/> доступ к проверенным производителям Китая.',
    },
  },
]
